module.exports = __webpack_public_path__ + "static/img_2307_optimized-09e160e606f5d8c57bf51824fc257f0f.jpg";